module.exports = __webpack_public_path__ + "img/item8.d6123c26.png";